import React from "react";
import "./PrivacyPolicy.css";
import Header from "../Header/Header";
import Footer from "../Footer/Footer";
import privacyImg from "../../Assets/privacy-policy.webp";


const PrivacyPolicy = () => {
  return (
    <div>
      <Header />
      {/* banner section start */}
      <section
        className="container-fluid  privacy_banner_section"
        style={{
          backgroundImage: `url(${privacyImg})`,
          backgroundPosition: "center center",
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat",
        }}
      >
        <div className="container">
          <div className="row text-center">
            <div className="col-lg-12 col-md-12 col-sm-12">
              <div className="banner_text">
                <h1>Privacy & Policy</h1>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* banner section end  */}

      {/* Privacy & Policy section start  */}
      <section className="container-fluid post_content_section py-5 bg-light">
  <div className="container">
    <div className="row">
      <div className="col-lg-12 col-md-12 col-sm-12">
        <div className="content_text p-4 bg-white shadow rounded">
          <h2 className="mb-4 text-primary">Privacy Policy</h2>
          <p><strong>Effective Date:</strong> May 2, 2025</p>
          <p><strong>Company Name:</strong> Khodiyar Automotive Glass Private Limited</p>
          <p><strong>Address:</strong> Mehsana, Gujarat, India</p>

          <p>
            At Khodiyar Automotive Glass Private Limited (referred to as “we,” “our,” or “us”), your privacy is important to us.
            This Privacy Policy explains how we collect, use, disclose, and protect the personal information of our clients,
            customers, and visitors.
          </p>

          <h5 className="mt-4 text-secondary">1. Information We Collect</h5>
          <ul>
            <li>When you contact us through our website, phone, or email.</li>
            <li>When you make an inquiry or place an order.</li>
            <li>When you visit our office or factory.</li>
          </ul>
          <p>Types of data we may collect:</p>
          <ul>
            <li>Name, email address, phone number, and postal address.</li>
            <li>Business-related information such as company name, GST number, and shipping address.</li>
            <li>Payment details (for billing purposes only).</li>
            <li>Technical data such as IP address (if interacting through website forms).</li>
          </ul>

          <h5 className="mt-4 text-secondary">2. How We Use Your Information</h5>
          <ul>
            <li>To fulfill orders and manage product shipments.</li>
            <li>To respond to inquiries and provide customer support.</li>
            <li>To send updates, invoices, and promotional offers (if subscribed).</li>
            <li>To improve our services and maintain quality assurance.</li>
            <li>For compliance with legal obligations.</li>
          </ul>

          <h5 className="mt-4 text-secondary">3. Sharing Your Information</h5>
          <p>We do not sell, trade, or rent your personal information. However, we may share it:</p>
          <ul>
            <li>With trusted third-party vendors for logistics or payment processing.</li>
            <li>With government authorities if required by law.</li>
            <li>Within our organization for internal business purposes.</li>
          </ul>

          <h5 className="mt-4 text-secondary">4. Data Security</h5>
          <p>
            We implement appropriate physical, technical, and administrative measures to protect your personal data from
            unauthorized access, misuse, or disclosure. Our employees are trained to handle information securely and responsibly.
          </p>

          <h5 className="mt-4 text-secondary">5. Your Rights</h5>
          <p>You may request access to your personal information, ask for corrections, or request deletion where applicable. You also have the right to opt out of receiving marketing communications.</p>
          <p>To exercise these rights, please contact us at:</p>
          <ul>
            <li>📧 Email: [YourCompanyEmail@example.com]</li>
            <li>📞 Phone: [YourCompanyPhoneNumber]</li>
          </ul>

          <h5 className="mt-4 text-secondary">6. Retention Period</h5>
          <p>
            We retain your personal data only for as long as necessary to fulfill the purposes mentioned in this policy or as
            required by law.
          </p>

          <h5 className="mt-4 text-secondary">7. Third-Party Links</h5>
          <p>
            Our website or communication may contain links to third-party sites. We are not responsible for the privacy practices
            of such sites. Please review their privacy policies before providing any personal data.
          </p>

          <h5 className="mt-4 text-secondary">8. Changes to This Privacy Policy</h5>
          <p>
            We may update this policy from time to time. The updated version will be posted on our website with the revised date.
          </p>

          <h5 className="mt-4 text-secondary">Contact Us</h5>
          <p>If you have any questions about this Privacy Policy, feel free to contact:</p>
          <ul>
            <li><strong>Khodiyar Automotive Glass Private Limited</strong></li>
            <li>📍 Mehsana, Gujarat, India</li>
            <li>📧 [YourCompanyEmail@example.com]</li>
            <li>📞 [YourCompanyPhoneNumber]</li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</section>

      {/* Privacy & Policysection End   */}

      <Footer />
    </div>
  );
};

export default PrivacyPolicy;
